import {LookupProps} from 'components/grid-dx/MasterGrid';
import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useIntegrityCourse} from '../hooks';
import {lookupStatus} from './CourseGrid';

const IntegrityCourseGrid = (props: any) => {
  const loadCourse = useIntegrityCourse(props.data.key);
  return (
    <IntegrityRoleGrid
      dataSource={loadCourse}
      disabledExport={true}
      autoWidth={false}
      id={['iD_Course']}
      height={'30vh'}
      allowIntegrity={false}
      allowActions={false}>
      <Column caption={i18n2._('#Course')} dataField="iD_Course" />
      <Column caption={i18n2._('Documento')} dataField="doc_Number" />
      <Column caption={i18n2._('Nombre')} dataField="name" width={200} />
      <Column
        caption={i18n2._('Contenido')}
        dataField="content"
        width={200}
        visible={false}
      />
      <Column caption={i18n2._('Estado')} dataField="status">
        <Lookup
          dataSource={lookupStatus}
          valueExpr="id"
          displayExpr={(item: LookupProps) => {
            return i18n2._(item ? item.name : '');
          }}
        />
      </Column>
      <Column
        caption={i18n2._('Incluir en capacitación inicial')}
        dataField="included_capa_ini"
        visible={true}
      />
      <Column caption={i18n2._('Tipo de curso')} dataField="iD_Type" />
      <Column
        caption={i18n2._('Compania')}
        visible={false}
        dataField="company"
      />
      <Column
        caption={i18n2._('Fecha de vigencia')}
        dataField="dateVig"
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.dateVig)}
      />
      <Column
        caption={i18n2._('#Parent')}
        visible={false}
        dataField="iD_Parent"
      />
      <Column caption={i18n2._('Version')} dataField="version" />
      <Column caption={i18n2._('Puntaje')} dataField="score" visible={false} />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        visible={false}
        dataField="updateDate"
        defaultSortOrder={'desc'}
        dataType="date"
        format="dd/MM/yyyy"
        calculateCellValue={(row: any) => new Date(row.updateDate)}
      />
      <Column
        caption={i18n2._('Actualizado por')}
        visible={false}
        dataField="updatedBy"
      />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default IntegrityCourseGrid;
